import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSettingAction } from "data/actions";
import { settingValueSelector } from "data/reducers/selectors";

interface UsePersistSettingProps {
    name: string;
    defaultValue: Object;
    asObject?: boolean;
}

interface PersistSettingObjectProps {
    value: Object;
    setValue: (value: Object) => void;
}

export function usePersistSetting(
    params: UsePersistSettingProps & { asObject: true }
): PersistSettingObjectProps;

export function usePersistSetting(
    params: UsePersistSettingProps & { asObject?: false }
): [any, (value: Object) => void];

export function usePersistSetting({
    name,
    defaultValue,
    asObject = false,
}: UsePersistSettingProps):
    | PersistSettingObjectProps
    | [any, (value: Object) => void] {
    const dispatch = useDispatch();
    const value: any =
        useSelector((state: Object) => settingValueSelector(name, state)) ??
        defaultValue;

    const setValue = useCallback(
        (value: Object) => {
            dispatch(setSettingAction(name, value));
        },
        [name, dispatch]
    );

    if (asObject) {
        return { value, setValue };
    }
    return [value, setValue];
}
